import { FC, PropsWithChildren } from "react";
import { Severity } from "../../Helpers";
import styles from "./Alert.module.scss";
import { faCheck, faExclamationTriangle, faCircleInfo, faTimesCircle, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { classNames } from "../../Utilities";

interface AlertProps {
    severity: Severity;
    overrideIcon?: IconDefinition;
}

export const Alert: FC<PropsWithChildren<AlertProps>> = (props) => {
    const renderIcon = () => {
        if (props.overrideIcon) return <FontAwesomeIcon icon={props.overrideIcon} />;

        switch (props.severity) {
            case Severity.Info:
                return <FontAwesomeIcon icon={faCircleInfo} />;
            case Severity.Success:
                return <FontAwesomeIcon icon={faCheck} />;
            case Severity.Warning:
                return <FontAwesomeIcon icon={faExclamationTriangle} />;
            case Severity.Danger:
                return <FontAwesomeIcon icon={faTimesCircle} />;
            default:
                return null;
        }
    };

    const getStyle = () => {
        switch (props.severity) {
            case Severity.Primary:
                return styles.primary;
            case Severity.Secondary:
                return styles.secondary;
            case Severity.Info:
                return styles.info;
            case Severity.Success:
                return styles.success;
            case Severity.Warning:
                return styles.warning;
            case Severity.Danger:
                return styles.danger;
            default:
                return styles.primary;
        }
    };

    return (
        <div className={classNames([styles.container, getStyle()])}>
            {!!renderIcon() && (
                <div className={styles.icon}>
                    {renderIcon()}
                </div>
            )}
            <div className={styles.content}>
                {props.children}
            </div>
        </div>
    );
};